import { Modal, ModalBody, ModalFooter, ModalHeader } from '@windmill/react-ui';
import { FormattedMessage } from 'react-intl';
import Button from '../_common/Button/Button';

interface ConfirmCancelModalProps {
  isOpen: boolean;
  close: () => void;
  confirm: () => void;
}

export default function ConfirmCancelModal({ isOpen, close, confirm }: ConfirmCancelModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={close}>
      <ModalHeader>
        <FormattedMessage id="cancel-signing-form" />
      </ModalHeader>
      <ModalBody>
        <FormattedMessage id="permanent-cancel-signing-form" />
      </ModalBody>
      <ModalFooter>
        <Button onClick={close} layout="outline">
          <FormattedMessage id="cancel" />
        </Button>
        <Button onClick={() => {
          confirm();
          close();
        }}
        >
          <FormattedMessage id="delete" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
